import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ba0c8f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

import { PropType } from 'vue'
import { addUserIconParams } from '@/use/usePath'

type Size = 'normal' | 'small' | 'medium'


export default /*#__PURE__*/_defineComponent({
  props: {
  user_image_url: String,
  size: {
    type: String as import('vue').PropType<Size>,
    default: 'normal',
  },
  is_deleted_in_30_days: Number,
  userType: String as PropType<'alumni' | 'employee' | 'yelloop' | 'community_admin' | 1 | 2 | 3>,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.is_deleted_in_30_days === 1 && __props.userType !== 'community_admin' && __props.userType !== 3)
    ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: __props.user_image_url ? _unref(addUserIconParams)(__props.user_image_url, __props.userType!) : require('@/assets/images/user-empty.svg'),
        alt: "user avatar",
        class: _normalizeClass(['rounded-circle hidden-image', __props.size])
      }, null, 10, _hoisted_1))
    : (__props.is_deleted_in_30_days === 2 && __props.userType !== 'community_admin' && __props.userType !== 3)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: require('@/assets/images/user-empty.svg'),
          alt: "user avatar",
          class: _normalizeClass(['rounded-circle', __props.size])
        }, null, 10, _hoisted_2))
      : (_openBlock(), _createElementBlock("img", {
          key: 2,
          src: __props.user_image_url ? _unref(addUserIconParams)(__props.user_image_url, __props.userType!) : require('@/assets/images/user-empty.svg'),
          alt: "user avatar",
          class: _normalizeClass(['rounded-circle', __props.size])
        }, null, 10, _hoisted_3))
}
}

})